function getFolderPath(folder) {
  let filePath = `${folder.name}`;
  while (folder.parent != null) {
    filePath = `${folder.parent.name}/${filePath}`;
    folder = folder.parent;
  }
  return filePath;
}

export default getFolderPath;
